// extracted by mini-css-extract-plugin
module.exports = {"Navigation":"Navigation_Navigation__1pDaA","NavigationItems":"Navigation_NavigationItems__3WC4A","Logo":"Navigation_Logo__1wOez","LogoImg":"Navigation_LogoImg__3Hq19"};